const EXPECTED_PIP_OPEN_REJECTION_NAMES = new Set([
  'AbortError',
  'NotAllowedError',
  'NotSupportedError',
  'SecurityError',
]);

const EXPECTED_PIP_OPEN_REJECTION_MESSAGES = [
  /transient activation/i,
  /user activation/i,
  /user gesture/i,
  /permission (?:denied|dismissed|cancel(?:l)?ed)/i,
  /requires https or file protocol/i,
  /top-level browsing context/i,
  /picture-in-picture.*(?:disabled|not supported)/i,
];

function getErrorName(error: unknown): string | undefined {
  if (error !== null && typeof error === 'object' && 'name' in error) {
    const name = (error as { name?: unknown }).name;
    return typeof name === 'string' ? name : undefined;
  }
  return undefined;
}

function getErrorMessage(error: unknown): string | undefined {
  if (error instanceof Error) {
    return error.message;
  }
  if (error !== null && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    return typeof message === 'string' ? message : undefined;
  }
  return typeof error === 'string' ? error : undefined;
}

export function getPipOpenRejectionContext(error: unknown) {
  const name = getErrorName(error);
  const message = getErrorMessage(error);

  return {
    ...(name ? { errorName: name } : {}),
    ...(message ? { errorMessage: message } : {}),
  };
}

export function isExpectedPipOpenRejection(error: unknown): boolean {
  const name = getErrorName(error);
  if (name && EXPECTED_PIP_OPEN_REJECTION_NAMES.has(name)) {
    return true;
  }

  const message = getErrorMessage(error);
  return (
    message !== undefined &&
    EXPECTED_PIP_OPEN_REJECTION_MESSAGES.some((pattern) => pattern.test(message))
  );
}
